import { ColDef, ICellRendererParams, themeAlpine } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import startCase from "lodash.startcase";
import React, { useMemo } from "react";

import { OrganizationSummarySubscriptionDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { formatDeprecatedName } from "@src/components/BillingPanel/components/ManagePlans/components/ManageSubscriptionsTable/deprecated-subscription-utils";
import { BillingServiceBadge } from "@src/features/admin/components/Icons/BillingServiceBadge";
import { CurrencyFormat } from "@src/features/admin/components/utils";
import { StatusColumn } from "@src/features/admin/pages/overview/components/Tables/DeprecatedSubscriptionsTable.tsx/renderers/StatusColumn";
import { theme } from "@src/theme";

interface SubscriptionsTableProps {
  subscriptions: OrganizationSummarySubscriptionDto[];
}

const DeprecatedBillingProviderColumn = (
  params: ICellRendererParams<OrganizationSummarySubscriptionDto>
) => {
  return (
    <BillingServiceBadge
      service={params.data?.billingProvider || "shopify"}
      deprecated={true}
    />
  );
};

const myTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
});

export const DeprecatedSubscriptionsTable = ({
  subscriptions,
}: SubscriptionsTableProps) => {
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
    };
  }, []);

  const columnDefs: ColDef<OrganizationSummarySubscriptionDto>[] = useMemo(
    () => [
      {
        headerName: "",
        sortable: true,
        maxWidth: 100,
        cellRenderer: DeprecatedBillingProviderColumn,
      },
      {
        headerName: "Name",
        field: "name",
        sortable: true,
        cellStyle: { justifyContent: "start", paddingLeft: "0px" },
        valueFormatter: (params) => {
          return formatDeprecatedName(params.data?.name);
        },
      },
      // {
      //   headerName: "Quantity",
      //   field: "quantity",
      //   sortable: true,
      //   valueFormatter: (params) => {
      //     const val = params.data?.name?.split("K;").shift();
      //     if (isNaN(Number(val))) {
      //       return "-";
      //     }
      //
      //     return val ? DecimalFormat.format(ensureNumber(val) * 1000) : "0";
      //   },
      // },
      {
        headerName: "Price",
        field: "price",
        sortable: true,
        valueFormatter: (params) => {
          return CurrencyFormat.format(params.value);
        },
      },
      {
        headerName: "Interval",
        field: "interval",
        sortable: true,
        valueFormatter: (params) => {
          return startCase(params.value);
        },
      },
      {
        headerName: "Status",
        field: "status",
        sortable: true,
        cellRenderer: StatusColumn,
      },
    ],
    []
  );

  return (
    <Grid item sx={{ width: "100%" }}>
      <AgGridReact<OrganizationSummarySubscriptionDto>
        theme={myTheme}
        rowData={subscriptions}
        defaultColDef={defaultColDef}
        columnDefs={columnDefs}
        headerHeight={25}
        domLayout={"autoHeight"}
        suppressCellFocus={true}
        suppressRowHoverHighlight={true}
      />
    </Grid>
  );
};
